/**
 * Created by Rodrigo Quesada on 05/02/17.
 */
import {Injectable} from '@angular/core';
import {Observable, ReplaySubject} from 'rxjs';
import {Response} from '@angular/http';
import {Model} from '../../../common/model.class';
import {Service} from '../../../common/service.class';
import {ControlledSubstancePermit} from './controlled-substance-permit.model';
import ProjectionInformation = Model.ProjectionInformation;

@Injectable()
export class ControlledSubstancePermitService {

    private _service: Service;

    private _changesSubject$ = new ReplaySubject<boolean>(1);
    changes$: Observable<boolean> = this._changesSubject$;

    protected readonly _modelType = ControlledSubstancePermit;
    private readonly _basePath: string = 'currentUser';

    constructor(svcm: Service.InjectedMembers) {
        this._service = new Service(svcm, 'professionalLicense');
    }

    doesCurrentUserModelEntryExist(professionalLicenseIndex: number): Observable<boolean> {
        return this._service.exists(this._modelType, this._pathFor(professionalLicenseIndex));
    }

    getCurrentUserModelEntry(professionalLicenseIndex: number, projection?: ProjectionInformation): Observable<ControlledSubstancePermit|undefined> {
        return this._service.get(this._modelType, this._pathFor(professionalLicenseIndex), projection);
    }

    updateCurrentUserModelEntry(professionalLicenseIndex: number, model: ControlledSubstancePermit): Observable<Response> {
        return this._service.update(model, this._pathFor(professionalLicenseIndex)).do(() => this._changesSubject$.next(true));
    }

    private _pathFor(professionalLicenseIndex: number) { return `${this._basePath}/${professionalLicenseIndex}/permit`; }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/licenses-certifications/professional/permit/controlled-substance-permit.service.ts